import { useSyncExternalStore } from 'react';
import { subscribeAuthError, getAuthErrorSnapshot, resetReauthGuard } from '@lib/apiClient';

/**
 * Visible auth-error surface. Renders only after the ONE permitted interactive re-auth has been
 * spent and a gated /api call 401s again (the alternative is a silent dead page or a redirect
 * storm). Try again is the named explicit reset: it re-arms the single re-auth and reloads.
 */
export function AuthErrorBanner() {
  const hasError = useSyncExternalStore(subscribeAuthError, getAuthErrorSnapshot);
  if (!hasError) return null;
  return (
    <div
      role="alert"
      className="fixed inset-x-0 top-0 z-[1000] flex items-center justify-center gap-3 bg-red-600 px-4 py-2 text-sm font-semibold text-white shadow-md"
    >
      <span>Your sign-in could not be confirmed. Press Try again to sign in.</span>
      <button
        type="button"
        className="rounded border border-white/60 px-2 py-0.5 text-xs font-bold uppercase tracking-wide hover:bg-white/10"
        onClick={() => {
          resetReauthGuard();
          window.location.reload();
        }}
      >
        Try again
      </button>
    </div>
  );
}
